module.exports = __webpack_public_path__ + "img/bg-yellow.32c08023.jpg";